<template>
    <transition name="modal">
        <div class="dialog-modal-mask">
            <div class="import-panel" @click.stop>
                <div class="dialog-title" v-t="'message.title_csv_import'">
                </div>
                <div class="dialog-body-import">
                    <el-tabs v-model="selectedTabName" type="card" @tab-click="handleTabClick">
                        <el-tab-pane v-for="item in tabItems" :label="item.label" :name="item.name" style="padding: 30px">
                            <div v-if="selectedTabName == 'errorInfo'">
                               <importErrorList :returnInfo="csvErrorInfo" :showType="0"></importErrorList>
                            </div>
                            <div v-else>
                                <div class="dialog-description" v-html="$t('message.hint_csv_common')">
                                </div>
                                <div class="import-step">
                                    <div class="import-step-title" v-t= "{ path: 'message.title_csv_download', args: { version: templateVersion } }">
                                    </div>
                                    <a :href=getCsvTemplatePath() :download=getCsvFilePath()>
                                        <span class="downloadButton">
                                            <img src="../assets/icon_download.svg" class="button-icon"/><span v-t="'message.button_download'"></span>
                                        </span>
                                    </a>
                                    <span style="padding: 0 0 0 20px;display:inline-block;">
                                        <button class="downloadButton" @click="csvExport()">
                                            <img src="../assets/icon_download.svg" class="button-icon"/><span v-t="'message.button_export'"></span>
                                        </button>
                                    </span>
                                    <div class="import-step-title" v-t="'message.title_csv_select_file'">
                                    </div>
                                    <div class="import-step-description" v-t="'message.hint_csv_note3'"></div>
                                    <label for="file_upload">
                                        <img src="../assets/icon_attach.svg" class="button-icon"/><span v-t="'message.action_selection'"/>
                                        <input id="file_upload" @change="selectedFile" type="file" name="file" style="display:none"/>
                                    </label>
                                    <span v-if="showUploadInfo">
                                        <span v-if="uploadFile == null" class='selected-filename' style="opacity: 0.6" v-t= "{ path: 'message.action_selection_file', args: { version: templateVersion } }">
                                        </span>
                                        <span v-else class='selected-filename'>
                                            {{ uploadFile.name}}
                                        </span>
                                    </span>
                                    <div v-if="selectedTabName == 'user'">
                                        <div class="import-step-title" v-t="'message.title_csv_import_user'"/>
                                        <div v-if="showSample" class="csv-sample" style="width: 1130px;overflow-x:scroll">
                                            <table width="1200px">
                                                <tr style="background-color:#f6f6f6">
                                                    <th width="3%"></th>
                                                    <th width="100px" v-t="'message.item_csv_command'"></th><th width="120px" v-t="'message.item_layerId'"></th><th width="100px" v-t="'message.item_userId'"></th>
                                                    <th width="120px" v-t="'message.item_userDisplayName'"></th><th width="100px" v-t="'message.item_password'"></th><th width="100px" v-t="'message.item_organization'"></th>
                                                    <th width="120px" v-t="'message.item_job_title'"></th><th width="100px" v-t="'message.item_tenant_phone'"></th><th width="100px" v-t="'message.item_option_speechToText'"></th>
                                                    <th width="100px" v-t="'message.item_option_translation'"></th><th width="100px" v-t="'message.item_option_location_tracking'"></th><th width="100px" v-t="'message.item_option_map_talk'"></th>
                                                    <th width="100px" v-t="'message.item_option_video'"></th><th width="100px" v-t="'message.item_option_interrupt_permission'"></th><th width="100px" v-t="'message.item_option_easyLogin'"></th>
                                                    <th width="100px" v-t="'message.item_option_easyLogin_QR'"></th>
                                                </tr>
                                                <tr>
                                                    <td style="background-color:#f6f6f6;text-align:center"> 1 </td><td> INSERT </td><td> ROOT-NODE </td><td> User010 </td><td v-t="'message.item_csv_sample_user1'"></td><td> Pass1234 </td>
                                                    <td v-t="'message.item_csv_sample_org1'"></td><td v-t="'message.item_csv_sample_job1'"></td><td></td><td style="text-align:center">YES</td><td style="text-align:center">NO</td><td style="text-align:center">YES</td>
                                                    <td style="text-align:center">NO</td><td style="text-align:center">NO</td><td style="text-align:center">NO</td><td style="text-align:center">NO</td><td style="text-align:center">NO</td>
                                                </tr>
                                                <tr>
                                                    <td style="background-color:#f6f6f6;text-align:center"> 2 </td><td> INSERT </td><td> ROOT-NODE </td><td> User011 </td><td v-t="'message.item_csv_sample_user2'"></td><td> Pass1234 </td>
                                                    <td></td><td></td><td>0356516120</td><td style="text-align:center">NO</td><td style="text-align:center">NO</td><td style="text-align:center">YES</td>
                                                    <td style="text-align:center">YES</td><td style="text-align:center">YES</td><td style="text-align:center">YES</td><td style="text-align:center">YES</td><td style="text-align:center">YES</td>
                                                </tr>
                                                <tr>
                                                    <td style="background-color:#f6f6f6;text-align:center"> 3 </td><td> MOVE </td><td> Level1</td><td> User012 </td><td class="csv-sample-no-use">－</td>
                                                    <td class="csv-sample-no-use">－</td><td class="csv-sample-no-use">－</td><td class="csv-sample-no-use">－</td><td class="csv-sample-no-use">－</td>
                                                    <td class="csv-sample-no-use">－</td><td class="csv-sample-no-use">－</td><td class="csv-sample-no-use">－</td><td class="csv-sample-no-use">－</td>
                                                    <td class="csv-sample-no-use">－</td><td class="csv-sample-no-use">－</td><td class="csv-sample-no-use">－</td><td class="csv-sample-no-use">－</td>
                                                </tr>
                                                <tr>
                                                    <td style="background-color:#f6f6f6;text-align:center"> 4 </td><td> UPDATE </td><td class="csv-sample-no-use">－</td><td> User013 </td><td v-t="'message.item_csv_sample_user3'"></td>
                                                    <td></td><td></td><td>#N/A</td><td>09011112222</td><td style="text-align:center">YES</td><td style="text-align:center">YES</td><td style="text-align:center">YES</td>
                                                    <td style="text-align:center">YES</td><td class="csv-sample-no-use">－</td><td class="csv-sample-no-use">－</td><td class="csv-sample-no-use">－</td>
                                                    <td class="csv-sample-no-use">－</td>
                                                </tr>
                                                <tr>
                                                    <td style="background-color:#f6f6f6;text-align:center"> 5 </td><td> DELETE </td><td class="csv-sample-no-use">－</td><td> User014 </td>
                                                    <td class="csv-sample-no-use">－</td><td class="csv-sample-no-use">－</td><td class="csv-sample-no-use">－</td><td class="csv-sample-no-use">－</td>
                                                    <td class="csv-sample-no-use">－</td><td class="csv-sample-no-use">－</td><td class="csv-sample-no-use">－</td><td class="csv-sample-no-use">－</td>
                                                    <td class="csv-sample-no-use">－</td><td class="csv-sample-no-use">－</td><td class="csv-sample-no-use">－</td><td class="csv-sample-no-use">－</td>
                                                    <td class="csv-sample-no-use">－</td>
                                                </tr>
                                            </table>
                                            <span v-t="'message.hint_csv_note1'"/>
                                        </div>
                                    </div>
                                    <div v-else-if="selectedTabName == 'talkgroup'">
                                        <div class="import-step-title" v-t="'message.title_csv_import_group'"/>
                                        <div  v-if="showSample" class="csv-sample" style="width: 1130px;overflow-x:scroll">
                                            <table width="1200px">
                                                <tr style="background-color:#f6f6f6">
                                                    <th width="3%"></th>
                                                    <th width="100px" v-t="'message.item_csv_command'"></th><th width="120px" v-t="'message.item_layerId'"></th><th width="120px" v-t="'message.item_groupId'"></th><th width="150px" v-t="'message.item_groupDisplayName'"></th><th width="140px" v-t="'message.item_talk_timer'"></th><th width="140px" v-t="'message.item_video_timer'"></th>
                                                    <th width="100px" v-t="'message.item_option_target_storage'"></th><th width="120px" v-t="'message.item_save_voice'"></th><th width="120px" v-t="'message.item_save_livecast'"></th><th width="100px" v-t="'message.item_talk_type'"></th><th width="100px" v-t="'message.item_option_speechToText'"></th>
                                                    <th width="100px" v-t="'message.item_option_translation'"></th><th width="100px" v-t="'message.item_option_location_information'"></th><th width="100px" v-t="'message.item_option_map_talk'"></th><th width="100px" v-t="'message.item_option_video'"></th>
                                                    <th width="100px" v-t="'message.item_option_lowBitRate'"></th><th width="100px" v-t="'message.item_option_easyLogin'"></th>
                                                </tr>
                                                <tr>
                                                    <td style="background-color:#f6f6f6;text-align:center"> 1 </td>
                                                    <td> INSERT </td><td> ROOT-NODE </td><td> Talk010 </td><td v-t="'message.item_csv_sample_org1'"></td><td> 600 </td><td> 600 </td>
                                                    <td style="text-align:center">DEFAULT</td><td style="text-align:center">YES</td><td style="text-align:center">NO</td><td style="text-align:center">SIMPLEX</td><td style="text-align:center">AZURE</td>
                                                    <td style="text-align:center">NO</td><td style="text-align:center">NO</td><td style="text-align:center">NO</td><td style="text-align:center">NO</td>
                                                    <td style="text-align:center">NO</td><td style="text-align:center">NO</td>
                                                </tr>
                                                <tr>
                                                    <td style="background-color:#f6f6f6;text-align:center"> 2 </td>
                                                    <td> UPDATE </td><td class="csv-sample-no-use">－</td><td> Talk002 </td><td></td><td>180</td><td></td>
                                                    <td style="text-align:center">DEFAULT</td><td style="text-align:center">NO</td><td></td><td style="text-align:center">FULL-DUPLEX</td><td style="text-align:center">NO</td>
                                                    <td style="text-align:center">NO</td><td style="text-align:center">NO</td><td style="text-align:center">NO</td><td style="text-align:center">NO</td>
                                                    <td style="text-align:center">NO</td><td style="text-align:center">NO</td>
                                                </tr>
                                                <tr>
                                                    <td style="background-color:#f6f6f6;text-align:center"> 3 </td>
                                                    <td> UPDATE </td><td class="csv-sample-no-use">－</td><td> Talk003 </td><td v-t="'message.item_csv_sample_group1'"></td><td></td><td></td>
                                                    <td style="text-align:center"></td><td style="text-align:center">YES</td><td></td><td style="text-align:center">INTERRUPT</td><td style="text-align:center">AUTO</td>
                                                    <td style="text-align:center">AZURE</td><td></td><td></td><td></td>
                                                    <td style="text-align:center">YES</td><td style="text-align:center">YES</td>
                                                </tr>
                                                <tr>
                                                    <td style="background-color:#f6f6f6;text-align:center"> 4 </td>
                                                    <td> DELETE </td><td class="csv-sample-no-use">－</td><td> Talk011 </td><td class="csv-sample-no-use">－</td><td class="csv-sample-no-use">－</td><td class="csv-sample-no-use">－</td>
                                                    <td class="csv-sample-no-use">－</td><td class="csv-sample-no-use">－</td><td class="csv-sample-no-use">－</td><td class="csv-sample-no-use">－</td><td class="csv-sample-no-use">－</td><td class="csv-sample-no-use">－</td>
                                                    <td class="csv-sample-no-use">－</td><td class="csv-sample-no-use">－</td><td class="csv-sample-no-use">－</td><td class="csv-sample-no-use">－</td><td class="csv-sample-no-use">－</td>
                                                </tr>
                                                <tr>
                                                    <td style="background-color:#f6f6f6;text-align:center"> 5 </td>
                                                    <td> MOVE </td><td> Level1 </td><td> Talk012 </td><td class="csv-sample-no-use">－</td><td class="csv-sample-no-use">－</td><td class="csv-sample-no-use">－</td>
                                                    <td class="csv-sample-no-use">－</td><td class="csv-sample-no-use">－</td><td class="csv-sample-no-use">－</td><td class="csv-sample-no-use">－</td><td class="csv-sample-no-use">－</td><td class="csv-sample-no-use">－</td>
                                                    <td class="csv-sample-no-use">－</td><td class="csv-sample-no-use">－</td><td class="csv-sample-no-use">－</td><td class="csv-sample-no-use">－</td><td class="csv-sample-no-use">－</td>
                                                </tr>
                                            </table>
                                            <span v-t="'message.hint_csv_note2'"/>
                                        </div>
                                    </div>
                                    <div v-else>
                                        <div class="import-step-title" v-t="'message.title_csv_import_userGroup'"/>
                                        <div v-if="showSample" class="csv-sample" style="width: 1130px;overflow-x:scroll">
                                            <div>
                                                <el-row :gutter="12">
                                                    <el-col :span="8">
                                                        <button class="transparent-button" style="width:100%" type="button" v-on:click="handleShowUserGroupSample('sample1')">
                                                            <div :class="{ 'arrow_box' : showUserGroupSample1, 'link-yes' : !showUserGroupSample1}" v-t="'message.title_add_remove_own_tenant'"></div>
                                                        </button>
                                                    </el-col>
                                                    <el-col :span="8">
                                                        <button class="transparent-button" style="width:100%" type="button" v-on:click="handleShowUserGroupSample('sample2')">
                                                            <div :class="{ 'arrow_box' : showUserGroupSample2, 'link-yes' : !showUserGroupSample2}" v-t="'message.title_add_remove_other_tenant'"></div>
                                                        </button>
                                                    </el-col>
                                                    <el-col :span="8">
                                                        <button class="transparent-button" style="width:100%" type="button" v-on:click="handleShowUserGroupSample('sample3')">
                                                            <div :class="{ 'arrow_box' : showUserGroupSample3, 'link-yes' : !showUserGroupSample3}" v-t="'message.title_mandatory_group_set'"></div>
                                                        </button>
                                                    </el-col>
                                                    <!--
                                                    <el-col :span="5">
                                                        <button class="transparent-button" style="width:100%" type="button" v-on:click="handleShowUserGroupSample('sample4')">
                                                            <div :class="{ 'arrow_box' : showUserGroupSample4, 'link-yes' : !showUserGroupSample4}" v-t="'message.title_sub_group_set'"></div>
                                                        </button>
                                                    </el-col>
                                                    -->
                                                </el-row>
                                            </div>
                                            <div v-if="showUserGroupSample1">
                                                <table width="100%">
                                                    <tr style="background-color:#f6f6f6">
                                                        <th width="3%"></th><th width="20%" v-t="'message.item_csv_command'"></th><th width="20%" v-t="'message.item_userId'"></th><th width="20%" v-t="'message.item_groupId'"></th>
                                                    </tr>
                                                    <tr>
                                                        <td style="background-color:#f6f6f6;text-align:center"> 1 </td><td> ADD </td><td> User001 </td><td> Talk001 </td>
                                                    </tr>
                                                    <tr>
                                                        <td style="background-color:#f6f6f6;text-align:center"> 2 </td><td> ADD </td><td> User002 </td><td> Talk001;Talk002;Talk003 </td>
                                                    </tr>
                                                    <tr>
                                                        <td style="background-color:#f6f6f6;text-align:center"> 3 </td><td> ADD </td><td> User003 </td><td> Talk001;Talk002;Talk003 </td>
                                                    </tr>
                                                    <tr>
                                                        <td style="background-color:#f6f6f6;text-align:center"> 4 </td><td> REMOVE </td><td> User012 </td><td> Talk002 </td>
                                                    </tr>
                                                    <tr>
                                                        <td style="background-color:#f6f6f6;text-align:center"> 5 </td><td> REMOVE </td><td> User013 </td><td> Talk001;Talk002 </td>
                                                    </tr>
                                                </table>
                                                <div v-t="'message.hint_csv_note4'"></div>
                                            </div>
                                            <div v-else-if="showUserGroupSample2">
                                                <table width="100%">
                                                    <tr style="background-color:#f6f6f6">
                                                        <th width="3%"></th><th width="20%" v-t="'message.item_csv_command'"></th><th width="20%" v-t="'message.item_userId'"></th><th width="20%" v-t="'message.item_groupId'"></th>
                                                    </tr>
                                                    <tr>
                                                        <td style="background-color:#f6f6f6;text-align:center"> 1 </td><td> ADD </td><td> User001@t01.buddyuser.net </td><td> Talk001 </td>
                                                    </tr>
                                                    <tr>
                                                        <td style="background-color:#f6f6f6;text-align:center"> 2 </td><td> ADD </td><td> User002@t01.buddyuser.net </td><td> Talk001;Talk002;Talk003 </td>
                                                    </tr>
                                                    <tr>
                                                        <td style="background-color:#f6f6f6;text-align:center"> 3 </td><td> ADD </td><td> User003@t01.buddyuser.net </td><td> Talk001;Talk002;Talk003 </td>
                                                    </tr>
                                                    <tr>
                                                        <td style="background-color:#f6f6f6;text-align:center"> 4 </td><td> REMOVE </td><td> User012@t01.buddyuser.net </td><td> Talk002 </td>
                                                    </tr>
                                                    <tr>
                                                        <td style="background-color:#f6f6f6;text-align:center"> 5 </td><td> REMOVE </td><td> User013@t01.buddyuser.net </td><td> Talk001;Talk002 </td>
                                                    </tr>
                                                </table>
                                                <div v-t="'message.hint_csv_note5'"></div>
                                            </div>
                                            <div v-else-if="showUserGroupSample3">
                                                <table width="100%">
                                                    <tr style="background-color:#f6f6f6">
                                                        <th width="3%"></th><th width="20%" v-t="'message.item_csv_command'"></th><th width="20%" v-t="'message.item_userId'"></th><th width="20%" v-t="'message.item_groupId'"></th>
                                                    </tr>
                                                    <tr>
                                                        <td style="background-color:#f6f6f6;text-align:center"> 1 </td><td> SET_MANDATORY_ON </td><td> User001 </td><td> Talk001 </td>
                                                    </tr>
                                                    <tr>
                                                        <td style="background-color:#f6f6f6;text-align:center"> 2 </td><td> SET_MANDATORY_ON </td><td> User002@t01.buddyuser.net </td><td> Talk001;Talk002;Talk003 </td>
                                                    </tr>
                                                    <tr>
                                                        <td style="background-color:#f6f6f6;text-align:center"> 3 </td><td> SET_MANDATORY_OFF </td><td> User003 </td><td> Talk001;Talk002;Talk003 </td>
                                                    </tr>
                                                    <tr>
                                                        <td style="background-color:#f6f6f6;text-align:center"> 4 </td><td> SET_DEFAULT_ON </td><td> User004 </td><td> Talk001 </td>
                                                    </tr>
                                                    <tr>
                                                        <td style="background-color:#f6f6f6;text-align:center"> 5 </td><td> SET_DEFAULT_ON </td><td> User005 </td><td> Talk001@t01.buddyuser.net </td>
                                                    </tr>
                                                    <tr>
                                                        <td style="background-color:#f6f6f6;text-align:center"> 6 </td><td> SET_DEFAULTSECOND_ON </td><td> User006 </td><td> Talk001 </td>
                                                    </tr>
                                                </table>
                                                <div v-t="'message.hint_csv_note4'"></div>
                                            </div>
                                            <div v-else>
                                                <table width="100%">
                                                    <tr style="background-color:#f6f6f6">
                                                        <th width="3%"></th><th width="20%" v-t="'message.item_csv_command'"></th><th width="15%" v-t="'message.item_userId'"></th><th width="15%" v-t="'message.item_groupId'"></th><th width="15%" v-t="'message.title_sub_group_id'"></th><th width="20%" v-t="'message.title_target_sub_group'"></th><th width="20%" v-t="'message.title_sub_group_name'"></th>
                                                    </tr>
                                                    <tr>
                                                        <td style="background-color:#f6f6f6;text-align:center"> 1 </td><td> ADD_TO_SUBGROUP </td><td> User001 </td><td> Group001 </td><td> － </td><td> 1;2;3 </td><td> － </td>
                                                    </tr>
                                                    <tr>
                                                        <td style="background-color:#f6f6f6;text-align:center"> 2 </td><td> REMOVE_FROM_SUBGROUP </td><td> User002 </td><td> Group001 </td><td> － </td><td> 2;3 </td><td> － </td>
                                                    </tr>
                                                    <tr>
                                                        <td style="background-color:#f6f6f6;text-align:center"> 3 </td><td> UPDATE_SUBGROUP　</td><td> － </td><td> Group001 </td><td> 1 </td><td> 2;4;6 </td><td> SubOffice </td>
                                                    </tr>
                                                </table>
                                                <div v-t="'message.hint_csv_note7'"></div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </el-tab-pane>
                    </el-tabs>
                </div>
                <hr class="dialog-hr">
                <div class="dialog-button-field">
                    <el-button class="dialog-cancel-button" @click="$emit('cancel')" v-t="'message.button_cancel'"></el-button>
                    <el-button v-if="selectedTabName == 'errorInfo'" class="dialog-ok-button" @click="$emit('cancel')" v-t="'message.button_end'"></el-button>
                    <el-button v-else class="dialog-ok-button" @click="$emit('import', selectedTabName , uploadFile)" :disabled="this.disableButton" v-t="'message.button_import'"></el-button>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
import server from "./ServerApi.js";
import charactercheck from './charactercheck.js';
import commonUtil from './commonutil.js';
import constants from './constants.js';
import ImportErrorList from './ImportErrorList.vue';

export default {
    data() {
        return {
            tabItems: [
                { name: constants.CSV_USER , label: commonUtil.getMessageText(this.$i18n,"item_user")},
                { name: constants.CSV_GROUP , label: commonUtil.getMessageText(this.$i18n,"item_group")},
                { name: constants.CSV_USER_GROUP , label: commonUtil.getMessageText(this.$i18n,"title_userGroup")}
            ],
            showSample: true,
            showUploadInfo: true,
            selectedTabName: constants.CSV_USER,
            disableButton: true ,
            uploadFile: null ,
            exportData: false,
            csvErrorInfo: null,
            showUserGroupSample1: true,
            showUserGroupSample2: false,
            showUserGroupSample3: false,
            showUserGroupSample4: false,
            templateVersion: constants.CSV_USER_TEMPLATE_VERSION,
        };
    },
    created: function() {
        if (this.showErrorInfo) {
            this.csvErrorInfo = this.csvResult;
            this.tabItems.push({ name: constants.CSV_ERROR_INFO , label: commonUtil.getMessageText(this.$i18n,"title_error_information") } );
            this.selectedTabName = constants.CSV_ERROR_INFO;
        } else {
            this.getImportProcessState();
        }
    },
    methods: {
        selectedFile: function(e) {
            e.preventDefault();
            let files = e.target.files;
            this.uploadFile = files[0];
            this.disableButton = false;
            this.reDrawUploadInfo();
        },
        handleTabClick(tab , event) {
            this.exportData = false;
            switch(this.selectedTabName) {
                case constants.CSV_USER:
                    this.templateVersion = constants.CSV_USER_TEMPLATE_VERSION;
                    break;
                case constants.CSV_GROUP:
                    this.templateVersion = constants.CSV_GROUP_TEMPLATE_VERSION;
                    break;
                case constants.CSV_USER_GROUP:
                    this.templateVersion = constants.CSV_USERGROUP_TEMPLATE_VERSION;
                    break;
            }
            this.reDrawSample();
        },
        csvExport() {
            this.$emit('export',this.selectedTabName)
        },
        getCsvTemplatePath() {
            switch(this.selectedTabName) {
                case constants.CSV_USER:
                    if (this.$i18n.locale == "ja") {
                        return "/static/importUserTemplate.csv";
                    } else {
                        return "/static/importUserTemplate_en.csv";
                    }
                case constants.CSV_GROUP:
                    if (this.$i18n.locale == "ja") {
                        return "/static/importTalkgroupTemplate.csv";
                    } else {
                        return "/static/importTalkgroupTemplate_en.csv";
                    }
                case constants.CSV_USER_GROUP:
                    if (this.$i18n.locale == "ja") {
                        return "/static/importUserTalkgroupTemplate.csv";
                    } else {
                        return "/static/importUserTalkgroupTemplate_en.csv";
                    }
            }
        },
        getCsvFilePath() {
            switch(this.selectedTabName) {
                case constants.CSV_USER:
                    return "importUserTemplate.csv";
                    break;
                case constants.CSV_GROUP:
                    return "importTalkgroupTemplate.csv";
                    break;
                case constants.CSV_USER_GROUP:
                    return "importUserTalkgroupTemplate.csv";
                    break;
            }
        },
        getImportProcessState() {
            let self = this;
            server.post("/getcsvprocstate")
                .then((res) => {
                    switch(res.data.status) {
                        case constants.STATUS_SUCCESS:
                            if (!res.data.errorInfo) {
                                return;
                            }
                            if (self.isUserMenuCsvProcessType(res.data.errorInfo.importType) && res.data.errorInfo.errorLineInfo.length > 0) {
                                self.tabItems.push({ name: constants.CSV_ERROR_INFO , label: commonUtil.getMessageText(self.$i18n,"title_error_information")} );
                                self.csvErrorInfo = res.data.errorInfo;
                            }
                            break;
                        default:
                            commonUtil.notifyMessage(self,"Error",commonUtil.getMessageText(self.$i18n,"error_server_api").replace("{functionName}","getImportProcessState").replace("{code}",res.data.status));
                            clearInterval(self.timerObj);
                            break;
                    }
                })
                .catch( function ( error ) {
                    commonUtil.putExceptionErrorMessage(self, "getImportProcessState", error);
                    clearInterval(self.timerObj);
                });
        },
        isUserMenuCsvProcessType(type) {
            return type === constants.CSV_USER || type === constants.CSV_GROUP || type === constants.CSV_USER_GROUP;
        },
        handleShowUserGroupSample(sampleType) {
            console.log("handleShowUserGroupSample", sampleType);
            switch(sampleType) {
                case "sample1":
                    this.showUserGroupSample1 = true;
                    this.showUserGroupSample2 = false;
                    this.showUserGroupSample3 = false;
                    this.showUserGroupSample4 = false;
                    break;
                case "sample2":
                    this.showUserGroupSample1 = false;
                    this.showUserGroupSample2 = true;
                    this.showUserGroupSample3 = false;
                    this.showUserGroupSample4 = false;
                    break;
                case "sample3":
                    this.showUserGroupSample1 = false;
                    this.showUserGroupSample2 = false;
                    this.showUserGroupSample3 = true;
                    this.showUserGroupSample4 = false;
                    break;
                case "sample4":
                    this.showUserGroupSample1 = false;
                    this.showUserGroupSample2 = false;
                    this.showUserGroupSample3 = false;
                    this.showUserGroupSample4 = true;
                    break;
            }
        },
        reDrawSample() {
            this.showSample = false;
            this.$nextTick(() => {
                 this.showSample = true
            })
        },
        reDrawUploadInfo() {
            this.showUploadInfo = false;
            this.$nextTick(() => {
                 this.showUploadInfo = true
            })
        }
    },
    watch: {
        'appData.csvProcessing'(newVal) {
            if (this.appData.csvProcessing) {
                this.disableButton = true;
            } else {
                this.disableButton = false;
                this.getImportProcessState();
            }
        }
    },
    components: {
        importErrorList: ImportErrorList
    },
    props: [ 'showErrorInfo' , 'csvResult' ]
}
</script scoped>

<style scoped>
table {
    margin-top: 10px;
    border-collapse: collapse;
}

table, th, td {
    border: 1px solid #dcdfe6;
    vertical-align: middle;
}

tr {
    height: 2em;
}

th {
    font-size: 12px;
}

td {
    padding-left: 8px;
}

.csv-sample {
    /* margin-top: 20px; */
}

.csv-sample-title {
    opacity: 0.6;
}

.csv-sample-no-use {
    opacity: 0.6;
    text-align: center;
}

button.download {
    height: 35px;
    width: 150px;
    background-color: #f6f6f6;
    border-radius: 4px;
}
label {
    font-size: 14px;
    color: #333B48;
    background-color: #f6f6f6;
    padding: 6px;
    border-radius: 4px;
    border: solid 1px;
    line-height: 33px;
    border-color: #dcdfe6;
    cursor: pointer;
}
.dialog-description {
    padding-top: 16px;
}
.downloadButton {
    line-height: 33px;
    font-size: 14px;
    color: #333B48;
    background-color: #f6f6f6;
    border-radius: 4px;
    border: solid 1px;
    width: 150px;
    border-color: #dcdfe6;
    text-align: center;
    cursor: pointer;
    display: inline-block;
    padding: 0;
    outline: 0;
}
.import-step {
    padding-top: 10px;
    padding-bottom: 10px;
}
.import-step-title {
    padding-top: 32px;
    padding-bottom: 10px;
    font-size: 12px;
    font-weight: bold;
}
.import-step-description {
    padding-bottom: 10px;
}
.selected-filename {
    padding-left: 10px;
}
.button-icon {
    height: 18px;
    vertical-align: middle;
    margin-right: 4px;
}
.el-tabs--border-card {
    box-shadow: none !important;
}
.el-tabs--border-card >>> .el-tabs__header .el-tabs__item:not(.is-disabled):hover {
    color: #5171cb !important;
}
.el-tabs--border-card >>> .el-tabs__header .el-tabs__item.is-active {
    color: #5171cb !important;
}
.el-tabs >>> .el-tabs__content {
    min-height: 520px;
}

a:link { color: #333B48; }
a:visited { color: #333B48; }
a:hover { color: #333B48; }
a:active { color: #333B48; }
a { text-decoration: none; }

.link-yes {
    color: #5171cb;
    padding-top: 10px;
    padding-bottom: 10px;
    font-size: 14px;
}

.arrow_box {
	position: relative;
	background: #fff;
	border: 1px solid #ddd;
	padding-top: 10px;
	padding-bottom: 10px;
    font-size: 14px;
    border-radius: 4px;
}
.arrow_box:after, .arrow_box:before {
	top: 100%;
	left: 50%;
	border: solid transparent;
	content: " ";
	height: 0;
	width: 0;
	position: absolute;
	pointer-events: none;
}

.arrow_box:after {
	border-color: rgba(255, 255, 255, 0);
	border-top-color: #fff;
	border-width: 10px;
	margin-left: -10px;
}
.arrow_box:before {
	border-color: rgba(0, 0, 0, 0);
	border-top-color: #ddd;
	border-width: 11px;
	margin-left: -11px;
}
</style>
